import { render, staticRenderFns } from "./GroupInviteUsersModal.vue?vue&type=template&id=3ff8bed2&"
import script from "./GroupInviteUsersModal.vue?vue&type=script&lang=js&"
export * from "./GroupInviteUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports